<template>
  <div class="container-fluid">
    <h2 class="mt-3 mb-3">ইনকাম স্টেটমেন্ট</h2>

    <div class="row mb-3">
      <form onsubmit="return false" class="form-inline">

        <label>রিপোর্ট শুরুর তারিখ</label>
        <datepicker :highlighted="{days: [5]}"  input-class="form-control ml-2 mr-2" v-model="from"
                    format="dd MMMM yyyy"></datepicker>
      হতে
        <datepicker :highlighted="{days: [5]}"  input-class="form-control ml-2 mr-2" v-model="to"
                    format="dd MMMM yyyy"></datepicker>

        <label>পর্যন্ত</label>
        <button class="btn btn-primary ml-4" @click="getList">রিপোর্ট তৈরী করুন</button>
      </form>

    </div>
    <h2 class="text-center font-weight-bold mt-3 mb-2">আয় বিবরণী</h2>
    <table class="table">
      <tbody>
      <tr>
        <td>(<i class="bi bi-plus-lg"></i>) বিক্রয় আয়</td>
        <td class="bn-number">{{ AmountService.commaDecimalWithCurrency( salesMot) }}</td>
      </tr>
      <tr>
        <td>(<i class="bi bi-dash-lg"></i>) বিক্রিত পণ্য ব্যয়</td>
        <td class="bn-number">{{ AmountService.commaDecimalWithCurrency( cogsMot) }}</td>
      </tr>
      <tr>
        <td>আপাত আয়</td>
        <td class="bn-number">{{ AmountService.commaDecimalWithCurrency( salesMot - cogsMot) }}</td>
      </tr>
      <tr>
        <td>(<i class="bi bi-dash-lg"></i>) বাদ খরচ</td>
        <td class="bn-number">{{ AmountService.commaDecimalWithCurrency( expenseMot) }}</td>
      </tr>
      <tr>
        <td>প্রকৃত আয়</td>
        <td class="bn-number">{{ AmountService.commaDecimalWithCurrency( salesMot-cogsMot-expenseMot) }}</td>
      </tr>
      </tbody>
    </table>


    <h1>দৈনিক বিক্রয় ও লাভের হিসাব</h1>
    <table class="table">
      <thead>
      <tr>
        <th>বিক্রয়ের তারিখ</th>
        <th class="text-right">মোট বিক্রয়</th>
        <th class="text-right">বিক্রিত পণ্য ব্যয়</th>
        <th class="text-right">লাভ</th>
        <th class="text-right">শতকরা লাভের পরিমান(%)</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="i in dateWise" v-bind:key="i.timestamp">
        <td class="bn-number">{{ AmountService.toBanglaTextDate(i.date) }}</td>
        <td class="bn-number text-right">{{ AmountService.commaDecimalWithCurrency( i.sales )}}</td>
        <td class="bn-number text-right">{{ AmountService.commaDecimalWithCurrency( i.cogs.toFixed(2) ) }}</td>
        <td class="bn-number text-right">{{ AmountService.commaDecimalWithCurrency( i.profit.toFixed(2) ) }}</td>
        <td class="bn-number text-right">{{ AmountService.commaDecimal( getPercent(i.sales, i.profit.toFixed(2) ) ) }}</td>
      </tr>
      </tbody>
      <tfoot>
      <tr class="font-weight-bold">
        <td><h4 class="font-weight-bold text-right">সর্বমোট</h4></td>
        <td class="bn-number text-right">{{ AmountService.commaDecimalWithCurrency(salesMot.toFixed(2))}}</td>
        <td class="bn-number text-right">{{ AmountService.commaDecimalWithCurrency(cogsMot.toFixed(2))}}</td>
        <td class="bn-number text-right">{{ AmountService.commaDecimalWithCurrency(profitMot.toFixed(2))}}</td>
        <td class="bn-number text-right">{{ AmountService.commaDecimal( getPercent(salesMot.toFixed(2), profitMot.toFixed(2)) ) }}%</td>

      </tr>
      </tfoot>
    </table>


    <h1>খরচের হিসাব</h1>
    <table class="table">
      <thead>
      <tr>
        <th>তারিখ</th>
        <th>খরচের খাতের নাম</th>
        <th class="text-right">খরচের পরিমান</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="e in expenseList" v-bind:key="e.id">
        <td class="bn-number">{{ AmountService.toBanglaTextDate(e.date) }}</td>
        <td>{{ e.expenseName }}</td>
        <td class="bn-number text-right">{{ AmountService.commaDecimalWithCurrency( e.amount.toFixed(2) ) }}</td>
      </tr>
      </tbody>
      <tfoot>
      <tr class="font-weight-bold">
        <td></td>
        <td><h4 class="font-weight-bold text-right">সর্বমোট</h4></td>
        <td class="bn-number text-right">{{ AmountService.commaDecimalWithCurrency(expenseMot.toFixed(2))}}</td>
      </tr>
      </tfoot>
    </table>

  </div>

</template>

<script>
import DateAdjust from "@/services/DateAdjust";
import Datepicker from 'vuejs-datepicker';
import AmountService from "@/services/amountService";
import Identity from "@/services/DataStructure/Identity";
// import BarChart from "@/components/GraphChartComponents/BarChart.vue";

export default {
  name: "ProfitReportComponent",
  computed: {
    AmountService() {
      return AmountService
    }
  },
  components: { Datepicker },
  data(){
    return{
      trxList: [],
      from: '',
      to: '',
      profitMot: 0.00,
      salesMot: 0.00,
      cogsMot: 0.00,
      dateWise: [],
      chartData: {
        labels: [],
        datasets: [
          {
            label: 'বিক্রয়',
            backgroundColor: '#0D47A1',
            data: []
          },
          {
            label: 'লাভ',
            backgroundColor: '#1B5E20',
            data: []
          }
        ]
      },
      purchaseExpense: [],
      operatingExpense: [],
      expenseList: [],
      expenseMot: 0.00,
      expenseIdentityList:[]
    }
  },
  methods:{
    getPercent(sales, profit){
      let s = parseFloat(sales)
      let p = parseFloat(profit)
      let percent = (p/s)*100
      return percent
    },
    getList(){
      this.chartData.labels =[]
      this.chartData.datasets[0].data = []
      this.chartData.datasets[1].data = []

      let year = new Date(this.from).getFullYear()
      let month = new Date(this.from).getMonth()+1
      if(month>0 && month<10){
        month = "0"+month
      }
      let date = new Date(this.from).getDate()
      if(date>0 && date<10){
        date = "0"+date
      }
      let fromDate = year+"-"+month+"-"+date+"T00:00:00Z"
      year = new Date(this.to).getFullYear()
      month = new Date(this.to).getMonth()+1
      if(month>0 && month<10){
        month = "0"+month
      }
      date = new Date(this.to).getDate()
      if(date>0 && date<10){
        date = "0"+date
      }
      let toDate = year+"-"+month+"-"+date+"T23:59:59Z"




      console.log("From Date: "+fromDate)
      this.from = new Date(fromDate).getTime()
      this.to = new Date(toDate).getTime()
      this.trxList = DateAdjust.printAllTrx()
      this.trxList = this.trxList.filter(x=> x.zz<=this.to && x.zz>=this.from).filter(x=>x.status=="out")
      this.profitMot = this.trxList.reduce((sum, x)=> sum+x.profit,0)
      this.cogsMot = this.trxList.reduce((sum, x)=> sum+(x.purchaseRate*x.quantity),0)
      this.salesMot = this.trxList.reduce((sum, x)=> sum+x.amount,0)
      this.getDateWise()
      this.getExpenseList()
    },
    getDateWise(){

      let result = [];
      this.trxList.reduce(function(res, value) {
        if (!res[value.date]) {

          let selfDate = value.date.split("-")
          let year = selfDate[2]
          let month = selfDate[1]
          if(month>0 && month<10){
            month = "0"+month
          }
          let date = selfDate[0]
          if(date>0 && date<10){
            date = "0"+date
          }
          let isoDate = year+"-"+month+"-"+date



          console.log(isoDate)

          let dateItem = new Date(isoDate).getTime();
          res[value.date] = { date: value.date, cogs:0, sales: 0, profit: 0, timestamp: dateItem, full: isoDate };
          res[value.date].timestamp = new Date(value.date).getTime();
          result.push(res[value.date])
        }
        res[value.date].sales += value.amount;
        res[value.date].cogs += (value.purchaseRate*value.quantity);
        res[value.date].profit += value.profit;
        return res;
      }, {});
      for(let i = 0; i<result.length-1; i++){
        for(let j = i+1; j<result.length; j++){
          if(result[i].timestamp>result[j].timestamp){
            let temp = result[i].timestamp;
            result[i].timestamp = result[j].timestamp
            result[j].timestamp = temp
          }
        }
      }

      this.dateWise = result;
     for(let i = 0 ; i<result.length; i++){
        this.chartData.labels.push(result[i].date)

       // for(let j = 0 ; j<result.length; j++) {
         this.chartData.datasets[0].data.push(result[i].sales)
       // }


       // for(let k = 0 ; k<result.length; k++) {
         this.chartData.datasets[1].data.push(result[i].profit)
       // }


     }
      console.log(this.chartData)
    },
    getExpenseList(){
      let expenseList = DateAdjust.printAllTrx()
      expenseList = expenseList.filter(x=> x.zz<=this.to && x.zz>=this.from).filter(x=>x.section=="expense")
      this.operatingExpense = expenseList.filter(x=>x.info.type=="expense")
      this.purchaseExpense  = expenseList.filter(x=>(x.type=="stock" && x.status=="in"))


      for(let i = 0; i<this.operatingExpense.length; i++){
        let formatData = {
          id: this.operatingExpense[i].id,
          date: this.operatingExpense[i].date,
          expenseName: this.operatingExpense[i].info.primaryName,
          amount: this.operatingExpense[i].amount
        }
        this.expenseList.push(formatData)
      }

      for(let i = 0; i<this.purchaseExpense.length; i++){
        if(this.purchaseExpense[i].transportationCost > 0){
          let formatData = {
            id: this.purchaseExpense[i].id,
            date: this.purchaseExpense[i].date,
            expenseName: "গাড়ি ভাড়া",
            amount: this.purchaseExpense[i].transportationCost
          }
          this.expenseList.push(formatData)
        }

        if(this.purchaseExpense[i].laborCost > 0){
          let formatData = {
            id: this.purchaseExpense[i].id,
            date: this.purchaseExpense[i].date,
            expenseName: "লেবার খরচ",
            amount: this.purchaseExpense[i].laborCost
          }
          this.expenseList.push(formatData)
        }

      }
      this.expenseMot = this.expenseList.reduce((sum, x)=> sum+x.amount,0)



    }

  },
  created() {
    this.expenseIdentityList = Identity.getIdentitiesByType("expense")
  }
}
</script>

<style scoped>
.shimmer{
  width: 230px;
  height: 24px;
  display: inline-block;
  -webkit-mask: linear-gradient(-60deg,#000 30%,#0005,#000 70%) right/300% 100%;
  background-repeat: no-repeat;
  animation: shimmerx 2s infinite;
  background-color: grey;
}
@keyframes shimmerx {
  100% {-webkit-mask-position:left}
}
.statement-title{
  font-size: 20px;
  padding-left: 48px;
}
</style>